export const state = {
  __page: null,
};
